export default "__VITE_ASSET__a51806b5__"